import React, { createContext, useContext, useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db, signUpWithEmailAndPassword, signInWithEmailAndPasswordAuth, signInWithGoogle, signOutUser } from '../firebase';

const AuthContext = createContext();

export function useAuth() {
    return useContext(AuthContext);
}

export function AuthProvider({ children }) {
    const [currentUser, setCurrentUser] = useState(null);
    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(true);

    const signup = async (email, password, name, gender) => {
        return await signUpWithEmailAndPassword(email, password, name, gender);
    };

    const login = async (email, password) => {
        return await signInWithEmailAndPasswordAuth(email, password);
    };

    const loginWithGoogle = async () => {
        return await signInWithGoogle();
    };

    const logout = async () => {
        setUserData(null);
        return await signOutUser();
    };

    const fetchUserData = async (uid) => {
        try {
            const userDoc = await getDoc(doc(db, 'users', uid));
            if (userDoc.exists()) {
                const data = userDoc.data();
                setUserData(data);
                return data;
            }
        } catch (error) {
            console.error('Error fetching user data:', error);
        }
        return null;
    };

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            setCurrentUser(user);
            
            if (user) {
                await fetchUserData(user.uid);
            } else {
                setUserData(null);
            }
            
            setLoading(false);
        });

        return unsubscribe;
    }, []);

    const value = {
        currentUser,
        userData,
        signup,
        login,
        loginWithGoogle,
        logout,
        fetchUserData,
        loading
    };

    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    );
}